import React from 'react';
import { CompanyConnection } from '../types/companyConnection/companyConnection';

export interface CompanyConnectionContextProps {
  companyConnections: Map<string, CompanyConnection>;
  setCompanyConnections: (connections: Map<string, CompanyConnection>) => void;
  companyConnectionsLoading: boolean;
}

const defaultContext: CompanyConnectionContextProps = {
  companyConnections: new Map(),
  setCompanyConnections: () => {},
  companyConnectionsLoading: false,
};

export const CompanyConnectionContext = React.createContext<CompanyConnectionContextProps>(defaultContext);
